var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7413 6.48421V6.92225C18.7413 7.18505 18.5799 7.36029 18.3378 7.36029H16.8853V8.01732H18.5395C18.9834 8.01732 19.3465 7.62309 19.3465 7.14125V6.48421C19.3465 6.30898 19.2255 6.13379 19.0237 6.13379C18.8623 6.13375 18.7413 6.26517 18.7413 6.48421Z",
    fill: "#FFE8F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96915 14.631C7.88845 15.5071 7.20254 16.2079 6.35522 16.2079H6.31487C5.42719 16.2079 4.70093 15.4194 4.70093 14.4557V13.4482C5.66927 14.0177 6.79905 14.4119 7.96915 14.631Z",
    fill: "#FFE8F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76408 3.54807C3.77278 2.9348 4.86221 2.54057 5.8709 2.40919L3.65176 0C2.96585 0.744652 2.64307 1.66454 2.64307 2.62823C2.68338 2.89099 2.72373 3.24141 2.76408 3.54807Z",
    fill: "#40596B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.42367 5.87065C-0.141223 6.48392 -0.141223 8.8493 0.42367 9.46257C0.706098 9.76918 2.03761 9.46257 2.03761 9.46257V5.87065C1.99726 5.87065 0.706098 5.56403 0.42367 5.87065Z",
    fill: "#FFE8F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4645 13.4482V14.4557C14.4645 15.4194 13.7383 16.2079 12.8506 16.2079H12.8102C11.9629 16.2079 11.277 15.5071 11.1963 14.631C12.4067 14.4119 13.4962 14.0177 14.4645 13.4482Z",
    fill: "#FFE8F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5823 14.7612C14.2619 14.7612 18.0555 11.5841 18.0555 7.66503C18.0555 3.74592 14.2619 0.568848 9.5823 0.568848C4.9027 0.568848 1.10913 3.74592 1.10913 7.66503C1.10913 11.5841 4.9027 14.7612 9.5823 14.7612Z",
    fill: "#FFB8D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69195 6.22123C3.95936 6.22123 4.17614 5.98589 4.17614 5.69558C4.17614 5.40527 3.95936 5.16992 3.69195 5.16992C3.42454 5.16992 3.20776 5.40527 3.20776 5.69558C3.20776 5.98589 3.42454 6.22123 3.69195 6.22123Z",
    fill: "#40596B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2459 2.36377H6.96023C6.79882 2.36377 6.63745 2.49519 6.63745 2.71419C6.63745 2.88942 6.75851 3.06461 6.96023 3.06461H12.2459C12.4073 3.06461 12.5283 2.93319 12.5283 2.71419C12.5283 2.539 12.4073 2.36377 12.2459 2.36377Z",
    fill: "#FFE8F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPig);
export default __webpack_public_path__ + "static/media/pig.c33aaec0960e95e0e2302c268df9ca5c.svg";
export { ForwardRef as ReactComponent };